import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDocumentGetQenoticeQueryResponse,
  GetApiDocumentGetQenoticeQueryParams,
  GetApiDocumentGetQenotice401,
  GetApiDocumentGetQenotice403,
} from "../../../types/GetApiDocumentGetQenotice";

export function getGetApiDocumentGetQenoticeUrl() {
  return `/api/Document/get-qenotice` as const;
}

/**
 * {@link /api/Document/get-qenotice}
 */
export async function getApiDocumentGetQenotice(
  params?: GetApiDocumentGetQenoticeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDocumentGetQenoticeQueryResponse,
    ResponseErrorConfig<
      GetApiDocumentGetQenotice401 | GetApiDocumentGetQenotice403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiDocumentGetQenoticeUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
